// src/components/ProyectoSection.js
import React from "react";
import "./ProyectoSection.css";
import img1 from "../assets/Planta.png";
import img1Sub1 from "../assets/sub1.jpg";
import img1Sub2 from "../assets/sub2.jpg";
import img2 from "../assets/Planta2.png";
import img3 from "../assets/Planta3.png";
import img4 from "../assets/Planta4.png";
import img5 from "../assets/Planta5.png";
import img6 from "../assets/Planta6.png";
import img7 from "../assets/Planta7.png";
import img8 from "../assets/Planta8.png";
import img9 from "../assets/Planta9.png";
import img10 from "../assets/Planta10.png";
import img2Sub1 from "../assets/2sub1.jpg";
import img2Sub2 from "../assets/2sub2.jpg";
import img3Sub1 from "../assets/3sub1.jpg";
import img3Sub2 from "../assets/3sub2.jpg";
import img4Sub1 from "../assets/4sub1.jpg";
import img4Sub2 from "../assets/4sub2.jpg";
import img5Sub1 from "../assets/5sub1.jpg";
import img5Sub2 from "../assets/5sub2.jpg";
import img6Sub1 from "../assets/6sub1.jpg";
import img6Sub2 from "../assets/6sub2.jpg";
import img7Sub1 from "../assets/7sub1.jpg";
import img7Sub2 from "../assets/7sub2.jpg";
import img8Sub1 from "../assets/8sub1.jpg";
import img8Sub2 from "../assets/8sub2.jpg";
import img9Sub1 from "../assets/9sub1.jpg";
import img9Sub2 from "../assets/9sub2.jpg";
import img10Sub1 from "../assets/10sub1.jpg";
import img10Sub2 from "../assets/10sub2.jpg";

const ProyectoSection = () => {
  // Data for the array section (example)
  const arrayData = [
    { left: "Superficie útil interior", right: "84.38 m²" },
    { left: "Superficie construida", right: "100.44 m²" },
    { left: "Superficie terrazaqs", right: "21.50 m²" },
    { left: "Superficie const. total con eecc.", right: "145.06 m²" },
  ];

  const arrayData2 = [
    { left: "Superficie útil interior", right: "84.50 m²" },
    { left: "Superficie construida", right: "99.59 m²" },
    { left: "Superficie terrazas", right: "22.20 m²" },
    { left: "Superficie const. total con eecc.", right: "144.85 m²" },
  ];

  const arrayData3 = [
    { left: "Superficie útil interior", right: "84.50 m²" },
    { left: "Superficie construida", right: "100.44 m²" },
    { left: "Superficie terrazas", right: "0 m²" },
    { left: "Superficie const. total con eecc.", right: "117.35 m²" },
  ];

  const arrayData4 = [
    { left: "Superficie útil interior", right: "83.83 m²" },
    { left: "Superficie construida", right: "99.59 m²" },
    { left: "Superficie terrazas", right: "0 m²" },
    { left: "Superficie const. total con eecc.", right: "116.36 m²" },
  ];

  const arrayData5 = [
    { left: "Superficie útil interior", right: "84.57 m²" },
    { left: "Superficie construida", right: "100.44 m²" },
    { left: "Superficie terrazas", right: "0 m²" },
    { left: "Superficie const. total con eecc.", right: "117.35 m²" },
  ];

  const arrayData6 = [
    { left: "Superficie útil interior", right: "83.86 m²" },
    { left: "Superficie construida", right: "99.59 m²" },
    { left: "Superficie terrazas", right: "0 m²" },
    { left: "Superficie const. total con eecc.", right: "116.36 m²" },
  ];

  const arrayData7 = [
    { left: "Superficie útil interior", right: "91.04 m²" },
    { left: "Superficie construida", right: "110.37 m²" },
    { left: "Superficie terrazas", right: "41.22 m²" },
    { left: "Superficie const. total con eecc.", right: "177.11 m²" },
  ];

  const arrayData8 = [
    { left: "Superficie útil interior", right: "89.69 m²" },
    { left: "Superficie construida", right: "110.53 m²" },
    { left: "Superficie terrazas", right: "41.07 m²" },
    { left: "Superficie const. total con eecc.", right: "177.12 m²" },
  ];

  const arrayData9 = [{ left: "", right: "" }];

  const arrayData10 = [{ left: "", right: "" }];

  return (
    <section className="proyecto-section">
      {/* Title Section */}
      <div className="proyecto-title-container">
        <h2 className="proyecto-title">Plantas</h2>
      </div>

      <div className="proyecto-divider"></div>

      {/* Reusable Subsection 1 */}
      <Subsection
        title="Vivienda 01"
        subtitle="Planta Primera"
        mainImage={img1}
        leftImage={img1Sub1}
        rightImage={img1Sub2}
        arrayData={arrayData}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />
      <Subsection
        title="Vivienda 02"
        subtitle="Planta Primera"
        mainImage={img2}
        leftImage={img2Sub1}
        rightImage={img2Sub2}
        arrayData={arrayData2}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />
      <Subsection
        title="Vivienda 03"
        subtitle="Planta Segunda"
        mainImage={img3}
        leftImage={img3Sub1}
        rightImage={img3Sub2}
        arrayData={arrayData3}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />
      <Subsection
        title="Vivienda 04"
        subtitle="Planta Segunda"
        mainImage={img4}
        leftImage={img4Sub1}
        rightImage={img4Sub2}
        arrayData={arrayData4}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Vivienda 05"
        subtitle="Planta Tercera"
        mainImage={img5}
        leftImage={img5Sub1}
        rightImage={img5Sub2}
        arrayData={arrayData5}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Vivienda 06"
        subtitle="Planta Tercera"
        mainImage={img6}
        leftImage={img6Sub1}
        rightImage={img6Sub2}
        arrayData={arrayData6}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Vivienda 07"
        subtitle="Planta Ático y Bajo Cubierta"
        mainImage={img7}
        leftImage={img7Sub1}
        rightImage={img7Sub2}
        arrayData={arrayData7}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Vivienda 08"
        subtitle="Planta Ático y Bajo Cubierta"
        mainImage={img8}
        leftImage={img8Sub1}
        rightImage={img8Sub2}
        arrayData={arrayData8}
        italicText="Incluye superficie construida de vivienda, terrazas y parte proporcional de zonas comunes."
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Aparcamiento"
        subtitle="Planta Baja"
        mainImage={img9}
        leftImage={img9Sub1}
        rightImage={img9Sub2}
        arrayData={arrayData9}
        italicText=""
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />

      <Subsection
        title="Trasteros"
        subtitle="Planta Entresuelo"
        mainImage={img10}
        leftImage={img10Sub1}
        rightImage={img10Sub2}
        arrayData={arrayData10}
        italicText=""
        footnote="NOTA: El presente documento es de carácter informativo y no contractual. Las superficies podrán sufrir las variaciones 
mínimas propias de las exigencias técnicas de la realización del Proyecto de Ejecución en la obra. La distribución del 
mobiliario restante no se entiende incluido en la vivienda, apareciendo en el plano a efectos meramente decorativos. "
      />
    </section>
  );
};

// Reusable Subsection Component
const Subsection = ({
  title,
  subtitle,
  mainImage,
  leftImage,
  rightImage,
  arrayData,
  italicText,
  footnote,
}) => {
  return (
    <div className="subsection">
      {/* Title and Subtitle */}
      <div className="subsection-header">
        <h3 className="subsection-title">{title}</h3>
        <p className="subsection-subtitle">{subtitle}</p>
      </div>
      {/* Full Width Image */}
      <div className="subsection-main-image">
        <img src={mainImage} alt={title} className="main-image" />
      </div>
      {/* Blue Background Section */}
      <div className="blue-section">
        <div className="blue-section-content">
          {/* Left: Two Images */}
          <div className="images-container">
            <div className="image-pair">
              <img src={leftImage} alt="Vista 1" className="small-image" />
              <img src={rightImage} alt="Vista 2" className="small-image" />
            </div>
          </div>
          {/* Right: Text Content */}
          <div className="text-container">
            {/* Array Data */}
            <div className="data-array">
              {arrayData.map((item, index) => (
                <div key={index} className="data-row">
                  <span className="data-left">{item.left}</span>
                  <span className="data-right">{item.right}</span>
                </div>
              ))}
            </div>

            {/* Italic Text */}
            <p className="italic-text">{italicText}</p>

            {/* Footnote */}
            <p className="footnote">{footnote}</p>
          </div>
        </div>
      </div>
      <div className="proyecto-divider"></div>"
    </div>
  );
};

export default ProyectoSection;
